import React from 'react';
import AboutImage from '../assets/aboutpic.webp';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-img">
        <img src={AboutImage} alt="aboutpic" width="700" height="700" loading="lazy" decoding="async" />
      </div>
      <div className="about-content">
        <h2 className="heading">About <span>Me</span></h2>
        <h3>Logistics & Supply Chain Management | Data Analytics</h3>
        <p>
          Hi, I'm Damith Wijekoon! I am currently studying Logistics and Supply Chain Management at European Nations Campus (ENC), while developing practical skills in logistics, supply chain, operations, and data analytics.
          <br />
          <br />
          My portfolio focuses on key supply chain areas such as procurement, inventory control, warehouse operations, logistics coordination, transportation, demand planning, order fulfillment, supplier performance, and operational KPI reporting.
          <br />
          <br />
          I build business-oriented Excel and Power BI dashboards that help identify stockout risks, warehouse transaction issues, OTIF failures, backorders, procurement gaps, and operational performance issues.
          <br />
          <br />
          My projects combine supply chain business logic with Microsoft Excel, Power BI, Power Query, DAX, and SQL to clean data, calculate KPIs, create dashboards, and present decision-focused insights.
          <br />
          <br />
          In addition, I have 7 years of practical experience in WordPress website development and SEO, including responsive website design, content optimization, plugin management, internal linking, image optimization, meta titles and descriptions, and technical SEO improvements.
        </p>
        <a href="https://www.linkedin.com/in/damith-wijekoon-06a522216/" className="btn">Read more</a>
      </div>
    </section>
  );
};

export default About;
